var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.67 71.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d29d2a;}.cls-2{fill:#fbbf12;}.cls-3{fill:#2a2a2a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,35.93c0-7.6,0-15.2,0-22.8C.06,5.15,6.08-.08,14.55,0,27.36.12,40,1.89,52.73,3c2.77.23,5.56.39,8.32.72,6.32.75,11.38,5.64,11.46,11.66.19,13.73.23,27.47,0,41.2A12.55,12.55,0,0,1,60.86,68.27Q45.59,69.5,30.34,71c-6.4.64-12.81,1.3-19.21.55A12.58,12.58,0,0,1,0,59.6C0,51.71,0,43.82,0,35.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.24,36c0-7.59,0-15.19,0-22.78C4.28,5.2,10,0,17.93.05c12.06.12,24,1.88,36,2.94,2.61.23,5.23.39,7.83.72a12.14,12.14,0,0,1,10.8,11.65c.18,13.73.22,27.46,0,41.18a12.24,12.24,0,0,1-11,11.73Q47.17,69.49,32.81,71c-6,.64-12.07,1.3-18.1.54A12.28,12.28,0,0,1,4.27,59.61c-.08-7.89,0-15.78,0-23.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.08,8.66c2.23.44,5,.89,7.79,1.55a5.74,5.74,0,0,1,3.66,3.45q10,20.84,19.92,41.71c1,2.05.36,3-2,3.29a4.82,4.82,0,0,1-5-2.64q-4.74-7.69-9.4-15.43c-2-3.37-4.06-6.76-6.1-10.14-.73-1.22-.8-1.23-1.84-.26L29,37.79a8.93,8.93,0,0,1-4.26,2.51,5.18,5.18,0,0,1-1.84.09c-1.91-.26-2.53-1.6-1.52-3,2.38-3.36,4.66-6.79,7-10.2a6.61,6.61,0,0,0,.51-7.47,18,18,0,0,1-2.06-8.46C26.77,9.4,27.64,8.6,30.08,8.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.48,59.72a2.71,2.71,0,0,1-2.7-2.64,6,6,0,0,1,.79-3.65q5-9,10-18.06c.81-1.46,1.36-1.47,2.26,0,1.2,1.89,2.36,3.79,3.55,5.69a2.23,2.23,0,0,1-.19,2.84q-5.79,7.29-11.54,14.6A2.7,2.7,0,0,1,28.48,59.72Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/D.da7977bd8b565c5d23cbe8d8e3fb1278.svg";
export { ForwardRef as ReactComponent };